import React from "react";
import { skillGroups } from "../data";

const Skills = () => {
  return (
    <section className="pb-8">
      <div className="max-w-3xl">
        <h1 className="font-display text-4xl tracking-tight text-stone-900 dark:text-stone-100 sm:text-5xl">
          Core tools and systems I work with regularly.
        </h1>
        <p className="mt-6 text-lg leading-8 text-stone-600 dark:text-stone-300">
          This page is retained for compatibility with the older portfolio
          routes, but the content is now organized the same way as the rest of
          the site: by capability rather than by logo wall.
        </p>
      </div>

      <div className="mt-12 grid gap-6 sm:grid-cols-2">
        {skillGroups.map((group) => (
          <section
            key={group.title}
            className="rounded-3xl border border-stone-200 bg-white p-6 dark:border-stone-800 dark:bg-stone-900"
          >
            <h2 className="text-lg font-semibold text-stone-900 dark:text-stone-100">
              {group.title}
            </h2>
            <div className="mt-4 flex flex-wrap gap-2">
              {group.items.map((item) => (
                <span
                  key={item}
                  className="rounded-full bg-stone-100 px-3 py-2 text-sm text-stone-600 dark:bg-stone-800 dark:text-stone-300"
                >
                  {item}
                </span>
              ))}
            </div>
          </section>
        ))}
      </div>
    </section>
  );
};

export default Skills;
